"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeInstructions = exports.executeTxInstructions = exports.createMutableTransactionInstructions = void 0;
const solana_contrib_1 = require("@saberhq/solana-contrib");
const createMutableTransactionInstructions = () => ({
    instructions: [],
    signers: [],
});
exports.createMutableTransactionInstructions = createMutableTransactionInstructions;
/**
 * Executes a TransactionInstructions
 * @param title
 * @param param1
 * @param param2
 * @returns Transaction signature
 */
const executeTxInstructions = (title, { instructions, signers }, { provider, payerSigner, options, }) => __awaiter(void 0, void 0, void 0, function* () {
    console.log(`Running tx ${title}`);
    const txEnv = new solana_contrib_1.TransactionEnvelope(provider, instructions.slice(), [
        // payer of the tx
        payerSigner,
        // initialize the swap
        ...signers,
    ]);
    const sig = yield txEnv.confirm(options);
    console.log(`${title} done at tx: ${sig.signature}`);
    return sig.signature;
});
exports.executeTxInstructions = executeTxInstructions;
const mergeInstructions = (mut, inst) => {
    mut.instructions.push(...inst.instructions);
    mut.signers.push(...inst.signers);
};
exports.mergeInstructions = mergeInstructions;
//# sourceMappingURL=instructions.js.map